const themeName = 'light';
const themeGroup = 'light';

const font = {
  color: {
    default: '#1D2433',
    secondary: '#4A505C',
    disabled: '#B0B3B8',
    title: '#151924',
  },
};

const text = {
  default: '#1D2433',
  secondary: '#4A505C',
  disabled: '#B0B3B8',
  title: '#151924',
};

const colors = {
  primary: {
    background: '#FFF8E1',
    default: '#FFC107',
    hover: '#FF8F00',
    pressed: '#FF6F00',
    text: '#FFF',
  },
  secondary: {
    background: '#E3F2FD',
    default: '#2196F3',
    hover: '#1565C0',
    pressed: '#0D47A1',
    text: '#FFF',
  },
  success: {
    background: '#E8F5E9',
    default: '#4CAF50',
    hover: '#2E7D32',
    pressed: '#1D5E20',
    text: '#FFF',
  },
  warning: {
    background: '#FFF3E0',
    default: '#FF9800',
    hover: '#EF6C00',
    pressed: '#E65100',
    text: '#FFF',
  },
  danger: {
    background: '#FFEBEE',
    default: '#F44336',
    hover: '#C62828',
    pressed: '#B71D1C',
    text: '#FFF',
  },
  inactive: {
    background: '#F5F5F5',
    default: '#9E9E9E',
    hover: '#757575',
    pressed: '#616161',
    text: '#FFF',
  },
  active: {
    background: '#E8F5E9',
    default: '#4CAF50',
    hover: '#2E7D32',
    pressed: '#1D5E20',
    text: '#FFF',
  },
  'green-dark': {
    background: '#E8F5E9',
    default: '#139A45',
    hover: '#0F7A36',
    pressed: '#0D6B2F',
    text: '#FFF',
  },
  'blue-primary': {
    background: '#E3F2FD',
    default: '#2563EB',
    hover: '#1D4ED8',
    pressed: '#1E40AF',
    text: '#FFF',
  },
  'white-primary': {
    background: '#FFF',
    default: '#FFF',
    hover: '#EFF6FF',
    pressed: '#DBEAFE',
    text: '#2563EB',
  },
  'purple-primary': {
    background: '#D4C6EC',
    default: '#6F42C1',
    hover: '#4E2E87',
    pressed: '#382161',
    text: '#FFF',
  },
  'back': {
    background: '#FFF',
    default: '#CCCACA',
    hover: '#BDBDBD',
    pressed: '#BDBDBD',
    text: '#52525B',
  },
  background: {
    primary: '#FFF',
    base: '#F8F9FC',
    secondary: '#F1F3F9',
  },
};

const divider = {
  color: '#E1E6EF',
};

const border = {
  default: '1px solid #0000003B',
  focused: `2px solid ${colors.primary.default}`,
  error: '2px solid #FF5656',
};

const input = {
  border: border.default,
  default: {
    background: `${colors.background.primary}`,
    color: `${font.color.default}`,
    placeholder: `${font.color.disabled}`,
  },
  hover: {
    background: `${colors.primary.background}`,
    color: `${font.color.default}`,
    placeholder: `${font.color.disabled}`,
  },
  focused: {
    background: `${colors.background.primary}`,
    color: `${font.color.default}`,
    placeholder: `${font.color.disabled}`,
    border: border.focused,
  },
  error: {
    background: `${colors.background.primary}`,
    color: `${font.color.default}`,
    placeholder: `${font.color.disabled}`,
    border: border.error,
  },
  disabled: {
    background: `${colors.background.secondary}`,
    color: `${font.color.disabled}`,
    placeholder: `${font.color.disabled}`,
  },
};

const link = {
  color: '#1F1F1F',
  decoration: 'underline',
};

const sidebar = {
  background: `${colors.background.primary}`,
  active: `${colors.primary.default}`,
  fontColor: `${font.color.secondary}`,
  fontColorActive: '#fff',
  submenu: {
    activeColor: `${colors.primary.default}`,
    activeBackground: `${colors.primary.background}`,
  },
};

const login = {
  background: 'src(/assets/images/common/login-bg.png)',
  color: '#000',
  iconColor: `${font.color.default}`,
};

const table = {
  backgroundTH: `${colors.background.secondary}`,
  hover: `${colors.primary.background}`,
  evenColor: `${colors.primary.background}`,
  borderColor: `${divider.color}`,
  fontColor: {
    TH: `${font.color.default}`,
    hover: `${font.color.default}`,
    body: `${font.color.default}`,
  },
};

const switchRadio = {
  background: 'rgba(0, 0, 0, 0.17)',
  statusActive: 'linear-gradient(to bottom, #00a9e9, #0061c6)',
  boxShadowActive: '0px 0px 5px 1px #0061c6',
  borderColorActive: '#0088EA',
  statusInactive:
    'linear-gradient(to top, #833a3a, #a04747, #be5555, #dd6363, #fd7171)',
  boxShadowInactive: '0px 6px 16px rgb(142 4 4 / 37%)',
  borderColorInactive: '#cf5d5d',
};

const body = {
  background: '#f5f5f5', // พื้นหลัง body
  color: '#fff', // สี global text color
  bgGray: '#f7f6f8', // พื้นหลัง body สีเทา
  bgWhite: '#fff', // พื้นหลัง body สีขาว
};

const modal = {
  background: '#000',
  color: '#fff',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  themeName,
  themeGroup,
  font,
  colors,
  link,
  sidebar,
  table,
  switchRadio,
  body,
  modal,
  input,
  text,
  login,
  divider,
  border,
};
